module.exports = __webpack_public_path__ + "static/img/minicons3.f7e1f6a9.png";